The response from the `deletePositionOpening` mutation.
